import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { NavMarker } from 'react-rhumb';
import { AnimatedStepBody } from '../animation/StepBodyAnimations';
import { useIsFramedCentredStep } from '../hooks/useIsFramedCentredStep';
import { OAuthSignupSection } from '../oauth/OAuthSignupSection';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { Data } from '../signup-data/DATA';
import { SignupDataInput } from '../signup-data/SignupDataInput';
import { getLandingPageButton } from '../step-landing-page/getLandingPageText';
import { renderLandingPageTitle } from '../step-landing-page/renderLandingPageTitle';
import { useLandingPage } from '../step-landing-page/useLandingPage';
import { UserInfoForm } from '../step-landing-page/UserInfoForm';
import NextButtonWrapper from '../views-components/NextButtonWrapper';
import PrivacyBanner from '../views-components/PrivacyBanner';
import { Step } from '../views/Step';
import { CompanySizeSelect } from './CompanySizeSelect';
import { HubletOnePage } from './HubletOnePage';
import { IndustrySelect } from './IndustrySelect';
import { JobRoleSelect } from './JobRoleSelect';

const OnePageSignupView = () => {
  const stepKey = Step.OnePageSignup;
  const {
    chooseEmailSignUp
  } = useLandingPage(stepKey);
  const {
    isMobile
  } = useResponsiveness();
  const {
    isFramedCentredStep
  } = useIsFramedCentredStep();

  const renderUserInfo = isCenterStepAligned => {
    return /*#__PURE__*/_jsx(UserInfoForm, {
      className: isCenterStepAligned ? '' : 'm-top-6'
    });
  };

  const renderContent = () => /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(OAuthSignupSection, {}), /*#__PURE__*/_jsxs("form", {
      action: "blue-button-in-all-fields-ios",
      onSubmit: chooseEmailSignUp,
      children: [renderUserInfo(isFramedCentredStep), /*#__PURE__*/_jsx(IndustrySelect, {}), /*#__PURE__*/_jsx(JobRoleSelect, {}), /*#__PURE__*/_jsx(SignupDataInput, {
        dataKey: Data.CompanyName
      }), /*#__PURE__*/_jsx(CompanySizeSelect, {}), /*#__PURE__*/_jsx(SignupDataInput, {
        dataKey: Data.CompanyDomain
      }), /*#__PURE__*/_jsx(HubletOnePage, {}), /*#__PURE__*/_jsx(NextButtonWrapper, {
        className: isFramedCentredStep ? '' : 'm-top-3',
        "data-selenium": "EMAIL_button",
        label: getLandingPageButton(stepKey),
        onClick: chooseEmailSignUp
      })]
    })]
  });

  const renderFooter = () => /*#__PURE__*/_jsx(PrivacyBanner, {});

  return /*#__PURE__*/_jsx(NavMarker, {
    name: Step.OnePageSignup,
    children: /*#__PURE__*/_jsx(AnimatedStepBody, {
      animationDelay: true,
      disableAnimation: isMobile,
      children: /*#__PURE__*/_jsxs("div", {
        "data-selenium": `${stepKey}_VIEW`,
        children: [renderLandingPageTitle({
          isMobile,
          isFramedCentredStep
        }), renderContent(), renderFooter()]
      })
    })
  });
};

export default OnePageSignupView;